import React from 'react';
import NavAdmin from '../nav-admin/nav-admin';

const HeaderDocument = () => (
    <div className="HeaderDocument">
        <section>
            <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar">
                <div className="container w-max2">
                    {/*Main Header*/}
                    <div className="admin-title">
                        <i className="bi bi-files" title="Documents Head Title"></i> <span className="spacer-margin2">Documents</span>
                    </div>
                    {/*Admin Menus*/}
                    <NavAdmin />
                </div>
            </nav>
        </section>
    </div>
);

export default HeaderDocument;
